export const addresses = {
  providerAddress: "0xe4820087f63f1CA2f487451c76ae8cA8C87Ba6bB",
};
